import { createAction } from "typesafe-actions";
import { Auth, AccessibilitySettings } from "types";

export const setAuth = createAction("APP/SET_AUTH")<Partial<Auth>>();

export const setAccessibilitySettings = createAction(
  "APP/SET_ACCESSIBILITY",
)<AccessibilitySettings>();
